import axios from "axios";
import React from "react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "./SendCampaign.css";

import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";

const SendAudioCampaign = () => {
  const initialState = {
    // mobile_no: "",
    // audio: "",
    // count: "",
    groupimport: "",
    txtimport: "",
    csvimport: "",
  };
  const [numbercounter, setNumberCounter] = useState("");
  const [mobile_no, setMobile_No] = useState("");
  const [count, setCount] = useState(0);
  const [audios, setAudios] = useState([]);
  const [audioId, setAudioId] = useState("");
  const [responseNumber, setResponseNumber] = useState("");
  const [contactGroupData, setContactGroupData] = useState([]);
  const [values, setValues] = useState(initialState);
  const [isloading, setLoading] = useState(false);
  const maxFileSize = 5000000;

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    document.body.className = theme;
    if (numbercounter.length == 0) {
      setNumberCounter(0);
    }
  }, [count]);

  const RowCount = (text) => {
    // Filter to allow only digits and newlines (remove all letters and special chars except newlines)
    const filteredText = text.replace(/[^0-9\n\r]/g, '');
    console.log(filteredText);
    var lines = filteredText.split(/\r|\r\n|\n/);
    console.log(lines);
    setCount(lines.length);
    // console.log("count", count);
    setNumberCounter(count);
    setMobile_No(filteredText);
  };

  const GroupRowCount = (text) => {
    // Filter to allow only digits and newlines (remove all letters and special chars except newlines)
    const filteredText = text.replace(/[^0-9\n\r]/g, '');
    console.log(filteredText);
    // return;
    var lines = filteredText.split(/\r|\r\n|\n/);
    console.log(lines);
    setCount(lines.length);
    // console.log("count", count);
    setNumberCounter(count);
    setMobile_No(filteredText);
  };

  const OnSubmit = () => {
    setLoading(true);
    if (!audioId) {
      toast.error("audio is mandatory");
      setLoading(false);
      return;
    }

    const token = localStorage.getItem("token");
    axios
      .post(
        `${BASE_URL}admin/addSendMessage`,
        {
          contact_no: mobile_no,
          msg_count: count,
          audio_id: audioId,
          response_number: responseNumber,
          media_type:"VOICE"
        },
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "Application/json",
            version: "1.0.0",
          },
        }
      )
      .then((response) => {
        if (response.data.success == false) {
          toast.error(response.data.message);
          setLoading(false);
        } else {
          toast.success(response.data.message);
          setLoading(false);
          setNumberCounter("");
          setMobile_No("");
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  const allowedExtensions = ["csv"];
  const handleFileChange = (e) => {
    // $('#thefile').change(function(e) {
    if (e.target.files != undefined) {
      var reader = new FileReader();
      var theInfo = "";
      var file = document.getElementById("thefile").files[0];
      reader.onload = function (e) {
        var lenlen = e.target.result.split("\n").length;
        for (let i = 0; i < lenlen; i++) {
          theInfo += e.target.result.split("\n")[i] + "\n";
        }
        // $('#res3').val('');
        // $('#res3').val(theInfo);
        // countLines();
        // $('#import-txt').fadeOut();
        // $('#import-group').fadeOut();
        // MNumber();
      };
      reader.readAsText(e.target.files.item(0));
    }
  };

  // const uploadAudio=(e)=>{
  //   if(audio.size>maxFileSize)
  //   {
  //     toast.error("file should be of 5 MB or Less");
  //   }
  //   setAudio(e.target.value)
  // }
  const showFile = async (e) => {
    e.preventDefault();
    const reader = new FileReader();
    reader.onload = async (e) => {
      let text = e.target.result;
      text = text.trim();
      var lines = text.split(/\r|\r\n|\n/);

      lines = lines.filter(function (el) {
        return el != "";
      });
      setCount(lines.length);
      setNumberCounter(count);
      setMobile_No(text);
    };
    reader.readAsText(e.target.files[0]);
  };

  const showCSVFile = async (e) => {
    e.preventDefault();
    const reader = new FileReader();
    reader.onload = async (e) => {
      let text = e.target.result;
      text = text.trim();
      console.log("text ==>", text);
      // alert(text)
      var lines = text.split(/\r|\r\n|\n/);

      lines = lines.filter(function (el) {
        return el != "";
      });
      console.log("line ==>", lines);

      setCount(lines.length);
      // console.log("count", count);
      setNumberCounter(count);
      console.log(count);
      setMobile_No(text);
    };
    reader.readAsText(e.target.files[0]);
  };

  const getApprovedAudios = () => {
    const token = localStorage.getItem("token");
    axios
      .get(`${BASE_URL}admin/getUserApprovedAudios`, {
        headers: {
          "x-access-token": `${token}`,
          version: "1.0.0",
          "Content-Type": "Application/json",
        },
      })
      .then((response) => {
        setAudios(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }; //end of GetAllAudios

  const GetAllContactGroup = () => {
    const token = localStorage.getItem("token");
    axios
      .post(
        `${BASE_URL}admin/getAllContactGroup`,
        { page: 1 },
        {
          headers: {
            "x-access-token": `${token}`,
            version: "1.0.0",
            "Content-Type": "Application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.data == false) {
          // toast.error(response.data.message);
        } else {
          // toast.success(response.data.message);
          setContactGroupData(response.data.data);
          console.log("transactionlog response:", response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getApprovedAudios();

    GetAllContactGroup();
    const theme = localStorage.getItem("theme");
    document.body.className = theme;
  }, []);

  return (
    <div className="send-campaign-container">
      <div className="send-campaign-card card">
        <div className="send-campaign-header card-header">
          <h6>Send Voice SMS</h6>
        </div>
        <div className="send-campaign-body card-body">
          {/* Enter Mobile Number */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Enter Mobile Number:-</label>
            <textarea
              rows={4}
              className="form-control-responsive"
              placeholder="Enter 10 digits mobile number here)"
              onChange={(e) => RowCount(e.target.value)}
              name="mobile_no"
              value={mobile_no}
            ></textarea>
          </div>

          {/* Select Audio */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Select Audio :-</label>
            <select
              className="form-control-responsive"
              onChange={(e) => setAudioId(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>
                Select audio
              </option>
              {audios.map((audio) => (
                <option key={audio.audio_id} value={audio.audio_id}>
                  {audio.audio_file_display_name}
                </option>
              ))}
            </select>
          </div>

          {/* Select Response Key */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Select Response Key :-</label>
            <select
              className="form-control-responsive"
              onChange={(e) => setResponseNumber(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>
                Select Response Key
              </option>
              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                <option key={number} value={number}>{number}</option>
              ))}
            </select>
          </div>

          {/* Count */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Count:-</label>
            <input
              type="text"
              className="form-control-responsive"
              name="numbercounter"
              value={count}
              disabled
            />
          </div>

          {/* Group Import */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">Group Import</label>
            <select
              className="form-control-responsive"
              onChange={(e) => GroupRowCount(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>--select--</option>
              {contactGroupData &&
                contactGroupData.map((item, index) => (
                  <option key={index} value={item.contact_no}>
                    {item.group_name}
                  </option>
                ))}
            </select>
          </div>

          {/* TXT Import */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">TXT Import</label>
            <input
              type="file"
              className="form-control-responsive"
              onChange={(e) => showFile(e)}
              id="csvInput"
              name="file"
            />
          </div>

          {/* CSV Import */}
          <div className="form-group-responsive">
            <label className="form-label-responsive">CSV Import</label>
            <input
              type="file"
              className="form-control-responsive"
              onChange={(e) => showCSVFile(e)}
              accept=".csv"
            />
          </div>

          {/* Submit Button */}
          <div className="submit-btn-container">
            {isloading ? (
              <button
                type="button"
                className="btn btn-primary"
                disabled
              >
                <i className="fa fa-spinner fa-spin  "></i>
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => OnSubmit()}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default SendAudioCampaign;
